/** @format */

const getUniqueObjects = <T, K extends keyof T>(arr: T[], key: K): T[] => {
  const seen = new Set();

  return arr.filter(item => {
    const value = item[key];

    if (seen.has(value)) {
      return false;
    }

    seen.add(value);

    return true;
  });
};

export {getUniqueObjects};
